import React from 'react';
import {Field, reduxForm} from 'redux-form';

class ThirdPartyForm extends React.Component {
  render(){
    const { handleSubmit, onAnotherAccount, onSignIn } = this.props;
    return(
      <form id="third-party-form" onSubmit={handleSubmit}>
        <label for="openidIdentifier"></label>
        <Field component="input" type="text" value="" name="openidIdentifier" />
        <p className="another-account">
          <a href="#" onClick={onAnotherAccount}>use another account</a>
        </p>
        <p className="btns">
          <a className="btn-gen-orange" href="#" onClick={onSignIn}>SIGN IN</a>
        </p>
      </form>
    );
  }

}

export default reduxForm({form: 'thirdPartyLoginForm'})(ThirdPartyForm)
